<template lang='pug'>
  header.app-header.navbar
    button.navbar-toggler.mobile-sidebar-toggler.d-lg-none(type='button', @click='mobileSidebarToggle')
      span.navbar-toggler-icon
    b-link.navbar-brand(to='/')
    b-navbar-nav.d-none.d-sm-block
      b-nav-item.text-white.text-right.px-3(v-html='this.currentUserPresenter()')
</template>
<script>
  import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'
  import HeaderDropdownTasks from './HeaderDropdownTasks.vue'
  import HeaderDropdownNotif from './HeaderDropdownNotif.vue'
  import HeaderDropdownMssgs from './HeaderDropdownMssgs.vue'

  import { mapGetters } from 'vuex'

  export default {
    name: 'header',
    components: {
      HeaderDropdownAccnt,
      HeaderDropdownTasks,
      HeaderDropdownNotif,
      HeaderDropdownMssgs
    },
    computed: {
      ...mapGetters({
        currentUser: 'currentUser'
      })
    },
    methods: {
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      currentUserPresenter () {
        if (this.currentUser) {
          return '<h6 class="my-0">' + this.currentUser.fullName + '</h6><small>' + this.currentUser.role + '</small>'
        }
      }
    }
  }
</script>

<style lang="sass">
  .navbar-brand
    background-size: 65% !important
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue